
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import React, { useEffect } from "react";

import LegislacaoComDiretorios from "./LegislacaoComDiretorios";
import LegislacaoComFiltro from "./LegislacaoComFiltro";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

const RedirectToLast = () => {
  const visualizacao = localStorage.getItem("visualizacao");
  
  useEffect(() => {
    if (visualizacao === "orgaos") {
      window.location.href = "/orgaos";
      return <LegislacaoComDiretorios />;
    }else if(visualizacao === "pesquisa"){
      window.location.href = "/pesquisa";
      return <LegislacaoComFiltro />;
    }
  }, [visualizacao]);
  
  return <LegislacaoComFiltro />;
};

const router = createBrowserRouter([
  {
    path: "/orgaos",
    element: <LegislacaoComDiretorios />
  },
  {
    path: "/",
    element: <RedirectToLast />
  },
  {
    path: "/pesquisa",
    element: <LegislacaoComFiltro />
  },

]);

root.render(
  <React.Suspense>
    <RouterProvider router={router} />
  </React.Suspense>
);
